import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, RemoveAllFilters } from "@insite/client-framework/Store/Pages/ProductList/Handlers/ClearAllProductFilters";

addToChainAfter(chain, RemoveAllFilters, props => {
    (props.result as any).wishlistIds = undefined;
    (props.result as any).categoryIds = undefined;
});